var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9662 27.0627C20.5443 26.3534 23.2435 25.9956 25.8619 25.6678C26.4258 25.5991 26.9494 25.9826 26.9897 26.5228C27.0703 27.0635 26.6672 27.5579 26.1435 27.6266C23.6057 27.9421 20.9876 28.2798 18.5303 28.9626C18.0066 29.1107 17.4424 28.8058 17.2813 28.2814C17.1202 27.7573 17.4425 27.2112 17.9662 27.0627Z",
    fill: "#434A54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.152 17.0069C14.3012 12.8559 18.974 9.23928 23.0426 4.97696C23.4051 4.57889 24.0496 4.55756 24.4525 4.92918C24.8553 5.30119 24.8954 5.92673 24.4926 6.32481C20.424 10.5994 15.7512 14.2279 11.602 18.391C11.1992 18.7796 10.5548 18.7852 10.152 18.4029C9.78946 18.021 9.74918 17.3955 10.152 17.0069Z",
    fill: "#434A54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37636 1.0409C2.25551 3.41671 2.1349 5.79252 2.01405 8.16873C2.01405 8.71292 1.53042 9.13311 0.966455 9.10665C0.402494 9.0798 -9.91821e-05 8.61656 -9.91821e-05 8.07197C0.12075 5.69221 0.241362 3.31285 0.362211 0.933484C0.402494 0.389291 0.885968 -0.028135 1.44993 0.00148363C1.97361 0.0311023 2.41664 0.497104 2.37636 1.0409Z",
    fill: "#434A54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.015af29f14ee8031fdd5f795b74c90c3.svg";
export { ForwardRef as ReactComponent };